// extracted by mini-css-extract-plugin
export default {"wrapper":"DashboardLanding_wrapper__7Najc","sidebarWrapper":"DashboardLanding_sidebarWrapper__tKIgz","sectionWrapper":"DashboardLanding_sectionWrapper__hWaRo"};